import React from 'react';
import PropTypes from 'prop-types';
import MobileNavigation from './mobile';
import DesktopNavigation from './desktop';
import { Route, Switch } from 'react-router-dom';
import NavBackButton from '~components/nav-back-button';

function Navigation({ isMobile, browserBackButton }) {
    const Nav = isMobile ? MobileNavigation : DesktopNavigation;
    return (
        <Switch>
            {/* <Route path="/map/:token" component={Nav} />
            <Route path="/map" component={Nav} /> */}
            <Route path="/laws/:id" render={() => <NavBackButton path="/laws" />} />
            <Route path="/news/:id" render={() => <NavBackButton path="/news" />} />
            <Route path="/laws-digests/:id" render={() => <NavBackButton path="/laws-digests" />} />
            <Route path="/laws-digests-old/:id" render={() => <NavBackButton path="/laws-digests-old" />} />
            <Route path="/news-digests/:id" render={() => <NavBackButton path="/news-digests" />} />
            <Route path="/statistics/:id" render={() => <NavBackButton path="/statistics" />} />
            <Route path="/reports/:id" render={() => <NavBackButton path="/reports" />} />
            <Route path="/theme-reports/:id" render={() => <NavBackButton path="/theme-reports" />} />
            <Route path="/new-project" render={() => <NavBackButton path="/laws" />} />
            {/* <Route path="/news" component={Nav} />
            <Route path="/laws" component={Nav} />
            <Route path="/user" component={Nav} /> */}
            <Route path="/" component={Nav} />
        </Switch>
    );
}

Navigation.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    browserBackButton: PropTypes.bool,
};

export default Navigation;
export { Navigation };



// WEBPACK FOOTER //
// ./src/components/navigation/index.js